import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../ui/Dialog/DialogActions";
import TextField from "../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import StateInfoField from "../StudyRequestInfo/StateInfoField";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "476px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  blockrow: {
    marginTop: 24
  }
});

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const formatDate2 = (dateStr) => {
  if (dateStr) {
    let parts = dateStr.split('.');
    if (parts && parts.length == 3) {
      let date = parts[2].concat('-',parts[1],'-',parts[0])
      return date;
    }
  }
  return null;
}

const formatWeekDays = days =>
  days.replace('MO', 'пн').replace('TU','вт').replace('WE','ср').replace('TH','чт').replace('FR','пт').replace('SU','сб');


const AcceptRequestModal = ({
  requestData,
  open,
  handleClose,
  handleAccept,
  classes,
  isAcceptingRequest,
  //acceptedRequest
}) => {
  const [comment, setComment] = React.useState("");

  const onConfirm = () => {
    handleAccept(requestData.id, comment);
    handleClose();
  };

  const onClose = () => {
    handleClose();
  };

  /*React.useEffect(() => {
    if (acceptedRequest && acceptedRequest.success) {
      setComment("");
      handleClose();
    }
  }, [acceptedRequest]);*/

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Подтверждение заявки</DialogTitle>
        <DialogContent>
          {requestData &&
          <div>
            <Typography className={classes.heading}>
              {`Заявка №${requestData.id} от ${formatDate(requestData.date)}`}
            </Typography>

            <div className={classes.blockrow}>
              <Typography className={classes.heading}>Данные обучающегося</Typography>
              {requestData.person && <>
              <StateInfoField field="ФИО" value={requestData.person.name}/>
              <StateInfoField field="Дата рождения" value={requestData.person.birthday}/>
              <StateInfoField field="Email" value={requestData.person.email}/>
              <StateInfoField field="Телефон" value={requestData.person.phone}/>
              <StateInfoField field="СНИЛС" value={requestData.person.snils}/> </>}
            </div>

            {requestData.plan &&
            <div className={classes.blockrow}>
              <Typography className={classes.heading}>Учебный план по программе</Typography>
              <StateInfoField field="Наименование программы" value={requestData.plan.name}/>
              <StateInfoField field="Код программы" value={requestData.plan.code}/>
              <StateInfoField field="Начало обучения" value={requestData.plan.dateStart}/>
              <StateInfoField field="Окончание обучения" value={requestData.plan.dateEnd}/>
            </div>}

            {requestData.group &&
            <div className={classes.blockrow}>
              <Typography className={classes.heading}>Учебная группа</Typography>
              <StateInfoField field="Код группы" value={requestData.group.code || '-'}/>
              <StateInfoField field="Вид группы" value={requestData.group.commercial ? 'Коммерческая' : 'Бесплатная'}/>
              <StateInfoField field="Начало занятий" value={requestData.group.startTime || '-'}/>
              <StateInfoField field="Окончание занятий" value={requestData.group.endTime || '-'}/>
              <StateInfoField field="Дни недели" value={requestData.group.recurrenceDays ? formatWeekDays(requestData.group.recurrenceDays) : '-'}/>
            </div>}

            <div className={classes.blockrow}>
              <TextField
                value={comment}
                onChange={e => setComment(e.target.value)}
                label="Комментарий специалиста"
              />
            </div>
          </div>
        }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isAcceptingRequest}
            disabled={isAcceptingRequest}
            onClick={() => onConfirm()}
            color="green"
          >
            Подтвердить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(AcceptRequestModal);
